import { Box, Drawer, styled } from '@mui/material';

export const StyledDrawer = styled(Drawer, {
  shouldForwardProp: prop => prop !== '$isOpen',
})<{ $isOpen: boolean }>(({ theme, $isOpen }) => ({
  zIndex: 1000,
  '& .MuiDrawer-paper': {
    backgroundColor: theme.palette.primary.main,
    overflow: 'hidden',
    borderRight: `1px solid ${theme.palette.common.white}`,
    transition: theme.transitions.create('width', {
      duration: $isOpen ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen / 2,
      easing: theme.transitions.easing.sharp,
    }),
    width: $isOpen ? '240px' : '64px',
    [theme.breakpoints.up('md')]: {
      width: $isOpen ? '240px' : '64px',
    },
  },
}));
  
export const DrawerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  position: 'relative',
  minHeight: '100vh',
}));
  
export const LogoContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: 'white',
  display: 'flex',
  justifyContent: 'center',
  height: '8rem',
  marginBottom: theme.spacing(3),
}));